import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const cartApi = createApi({
  reducerPath: 'cartApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.utkarsita.com/api/v1',
    // prepareHeaders: async (headers, { getState }) => {
    //   headers.set('Content-Type', 'application/json');
    //   return headers;
    // },
    credentials: 'include',
  }),
  tagTypes: ['Cart'],
  endpoints: (builder) => ({
    
    addToCart: builder.mutation({
        query: (body) => ({
          url: '/cart/add-to-cart',
          method: 'POST',
          body,
        }),
      }),
    addToGuestUserCart: builder.mutation({
        query: (body) => ({
          url: '/cart/gu-cart',
          method: 'POST',
          body,
        }),
      }),
      addToWishlist: builder.mutation({
        query: (productId) => {
          // Console log to check if productId is passed correctly
          console.log('Product ID:', productId);
      
          return {
            url: '/wishlist/add-new',
            method: 'POST',
            body: {
              wishlist: {
                product: productId,
              },
            },
          };
        },
      }),
      
      getCartItems: builder.query({
        query: () => ({
          url: '/cart/cart-items',
          method: 'GET',
        }), 
        providesTags: ['Cart'],
      }),

      getGuestCartItems: builder.query({
        query: () => ({
          url: '/cart/guest/cart-items',
          method: 'GET',
        }), 
        providesTags: ['Cart'],
      }),

      getAddresses: builder.query({
        query: () => ({
          url: '/address/all',
          method: 'GET',
        }), 
        providesTags: ['address'],
      }),
  }),
});

export const {
  useAddToCartMutation,
  useGetCartItemsQuery,
  useAddToWishlistMutation,
  useGetAddressesQuery,
  useAddToGuestUserCartMutation,
  useGetGuestCartItemsQuery
} = cartApi;
